<template>
    <div>
        <div class=" reveal">
            <div class="hidden-lg-and-up">
                <div class="text--secondary" style="font-size: 17px">
                    <span class="font-weight-bold" style="font-size: 20px">| </span>
                    <span>과외 수업이 끝이 아니에요!</span></div>
                <div class="black--text" style="font-size: 26px; font-weight: bold">IVYED는 숙제와 자습까지<br/>
                    모두 1:1로 관리되고 있어요
                </div>
            </div>
            <div class="hidden-md-and-down">
                <div class="text--secondary" style="font-size: 22px">
                    <span class="font-weight-bold" style="font-size: 22px">| </span>
                    <span>과외 수업이 끝이 아니에요!</span></div>
                <div class="black--text" style="font-size: 34px; font-weight: bold">IVYED는 숙제와 자습까지<br/>
                    모두 1:1로 관리되고 있어요
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "AboutIvyed1",
        mounted() {
            window.addEventListener("scroll", this.reveal);
        },
        destroyed() {
            window.removeEventListener("scroll", this.reveal);
        },
        methods: {
            reveal() {
                var reveals = document.querySelectorAll(".reveal");

                for (var i = 0; i < reveals.length; i++) {
                    var windowHeight = window.innerHeight;
                    var elementTop = reveals[i].getBoundingClientRect().top;
                    var elementVisible = 150;

                    if (elementTop < windowHeight - elementVisible) {
                        reveals[i].classList.add("active");
                    } else {
                        reveals[i].classList.remove("active");
                    }
                }
            },
        },
    };
</script>

<style>

    body {
        /*background: #42455a;*/
    }

    section {
        /*min-height: 100vh;*/
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
    }

    .each-title {
        font-size: 21px !important;
        text-align: left !important;
    }

    section:nth-child(1) {
        color: black;
    }

    section:nth-child(2) {
        color: black;
        background: #ffffff !important;
    }

    /* Add more styles for other sections as needed */
    section .container {
        /*margin: 100px;*/
        background-color: #ffffff !important;

    }

    section h1 {
        /*font-size: 3rem;*/
        /*margin: 20px;*/
    }

    section h2 {
        font-size: 40px;
        /*text-align: center;*/
        text-transform: uppercase;
    }

    section .text-container {
        display: flex;
        padding: 20px;
        margin-top: 10px;
    }

    section .text-container .text-box {
        /*margin: 20px;*/
        /*padding: 20px;*/
        /*background: #00c2cb;*/

    }

    section .text-container .text-box h3 {
        font-size: 30px;
        /*text-align: center;*/
        text-transform: uppercase;
        margin-bottom: 10px;
    }

    @media (max-width: 900px) {
        section h1 {
            font-size: 2rem;
            /*text-align: center;*/
        }

        section .text-container {
            flex-direction: column;
        }
    }

    .reveal {
        position: relative;
        transform: translateY(150px);
        opacity: 0;
        transition: 1s all ease;
    }

    .reveal.active {
        transform: translateY(0);
        opacity: 1;
    }
</style>

